export const PRIMARY_BUTTON =
  'cursor-pointer bg-primary-main text-white active:bg-secondary-main sm:hover:bg-secondary-main';
export const PRIMARY_BUTTON_WHITE =
  'cursor-pointer bg-white border border-solid border-transparent text-primary-main active:bg-transparent active:border-white active:text-white sm:hover:bg-transparent sm:hover:border-white sm:hover:text-white';
export const PRIMARY_BUTTON_WHITE_DARK_MODE =
  'cursor-pointer bg-white border border-solid border-transparent text-primary-light active:bg-transparent active:border-white active:text-white sm:hover:bg-transparent sm:hover:border-white sm:hover:text-white';
export const PRIMARY_BUTTON_DARK_MODE =
  'cursor-pointer bg-primary-light text-white active:bg-secondary-main sm:hover:bg-secondary-main';
export const PRIMARY_BUTTON_GRAY =
  'cursor-pointer bg-base-lighter text-white active:bg-gray-dark sm:hover:bg-gray-dark';

export const PRIMARY_BUTTON_DISABLED =
  'cursor-default bg-gray-light text-gray-dark pointer-events-none';
export const PRIMARY_BUTTON_WHITE_DISABLED =
  'cursor-default bg-base-lighter text-primary-main pointer-events-none';
export const PRIMARY_BUTTON_DARK_MODE_DISABLED =
  'cursor-default bg-base-lighter-56 text-gray-dark pointer-events-none';

export default {
  default: PRIMARY_BUTTON,
  white: PRIMARY_BUTTON_WHITE,
  'white-dark': PRIMARY_BUTTON_WHITE_DARK_MODE,
  gray: PRIMARY_BUTTON_GRAY,
  darkMode: PRIMARY_BUTTON_DARK_MODE,
  'default-disabled': PRIMARY_BUTTON_DISABLED,
  'white-disabled': PRIMARY_BUTTON_WHITE_DISABLED,
  'darkMode-disabled': PRIMARY_BUTTON_DARK_MODE_DISABLED,
};
